var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"fixed-icon",class:[ !_vm.transition ? 'fixed-transition' : ''],style:({ bottom: _vm.bottom + 'rem' }),on:{"click":_vm.event}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }